import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success("Innlogget");
      if (u.must_change_password) nav("/bytt-passord");
      else if (u.role === "admin") nav("/admin");
      else if (u.role === "fixer") nav("/verksted-dashbord");
      else nav("/mine-bestillinger");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="tk-container py-20 max-w-md" data-testid="login-page">
      <p className="tk-overline mb-3">Konto</p>
      <h1 className="text-3xl font-semibold mb-2">Logg inn</h1>
      <p className="text-sm text-slate-500 mb-8">
        Bruk din Tekkdeler-konto for å bestille, eller administrere verkstedet.
      </p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">E-post</label>
          <input
            type="email"
            required
            className="tk-input mt-1"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
          />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Passord</label>
          <input
            type="password"
            required
            className="tk-input mt-1"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
          />
        </div>
        <button type="submit" disabled={busy} className="tk-btn-primary w-full justify-center" data-testid="login-submit-btn">
          {busy ? "Logger inn …" : "Logg inn"}
        </button>
      </form>
      <p className="text-sm mt-4">
        <Link to="/glemt-passord" className="text-slate-500 hover:text-[#0B1C30] underline" data-testid="forgot-password-link">
          Glemt passord?
        </Link>
      </p>
      <p className="text-sm text-slate-500 mt-6">
        Ny her? <Link to="/registrer" className="text-[#0B1C30] font-medium underline" data-testid="goto-register-link">Opprett konto</Link>
      </p>
    </div>
  );
}
